/**
 * Compatibility shim for graphql/language/visitor.
 *
 * graphql 16.9+ moved QueryDocumentKeys from graphql/language/visitor to
 * graphql/language/ast and stopped re-exporting it from visitor. This shim
 * re-exports the full visitor API and adds QueryDocumentKeys so that older
 * packages (e.g. apollo-cache-inmemory) that import it from visitor continue
 * to work.
 *
 * Uses 'graphql/language/visitor.js' (explicit .js extension) so the exact-match
 * webpack alias ('graphql/language/visitor$') does NOT intercept this require,
 * preventing a circular dependency without needing absolute paths.
 */

/* eslint-disable */
module.exports = Object.assign({}, require('graphql/language/visitor.js'), {
  QueryDocumentKeys: require('graphql/language/ast').QueryDocumentKeys,
});
